/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components */
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class ActiveReports extends Component {
  // passed in — cards from the counts response, each { template, drafts,
  // periodIndex }. Entries rather than bare templates, so the period shown
  // and the period handed to onWriteReports are the backend's.
  cards = null;
  loadingReportId = null;
  onWriteReports = null;

  // state
  isExpanded = true;

  @action
  toggle() {
    this.toggleProperty('isExpanded');
  }
}
